module.exports = __webpack_public_path__ + "assets/img/grid.eb05b5dd.png";